const { appLogDebug } = require('../core/core.logger');
const { eurekoPonudbaTypes } = require('../schema/schema.ponudba');
const { appCustomTypes } = require('../schema/schema.app.custom');


class BdcaPremija {
    constructor() {
        this.calcParams = {
            paket: null,
            razmerje: null,
            datumRojstva: null,
            frekvenca: null,
            produktBdBasic: null
        };
        this.premija = null;
    }

    setCalcParam(param, value) {
        this.calcParams[param] = value;
    }

    /**
     * BASIC - paket, produktBdBasic, frekvenca
     * SCA, PCA - paket, razmerje, datumRojstva
     */
    validateParams() {

        const allowedPaketTypes = Object.values(appCustomTypes.PaketBDCA);
        if ( !allowedPaketTypes.includes(this.calcParams['paket']) ) {
            return false;
        }

        switch (this.calcParams['paket']) {
            case appCustomTypes.PaketBDCA.BDCA_STANDARD:
            case appCustomTypes.PaketBDCA.BDCA_PREMIUM:
                const allowedRazmerjeTypes = Object.values(eurekoPonudbaTypes.RazmerjeZZavarovalcem);
                if (!allowedRazmerjeTypes.includes(this.calcParams['razmerje'])) {
                    return false;
                }

                if (typeof(this.calcParams['datumRojstva']) !== 'number' ) {
                    return false;
                }

                break;
            case appCustomTypes.PaketBDCA.BDCA_BASIC:
                const allowedProduktTypes = Object.values(eurekoPonudbaTypes.ProduktBDBasic);
                
                if (!allowedProduktTypes.includes(this.calcParams['produktBdBasic'])) {
                    return false;
                }

                const allowedFrekvencaTypes = [
                    eurekoPonudbaTypes.FrekvencaPlacila.MESECNO,
                    eurekoPonudbaTypes.FrekvencaPlacila.LETNO,
                ];
                if (!allowedFrekvencaTypes.includes(this.calcParams['frekvenca'])) {
                    return false;
                }

                break;
        
            default:
                return false;
                break;
        }

        return true;

    }

    getPremijaNeto() {
        return this.premija?.neto;
    }

    getPremijaDavek() {
        return this.premija?.davek;
    }

    getPremijaBruto() {
        return this.premija?.bruto;
    }

    /**
     * @todo throw error.
     */
    calculate() {

        this.premija = null;
        if (!this.validateParams()) {
            return this;
        }

        let paket = this.calcParams['paket'], 
            datumRojstva    = null, 
            razmerje        = null, 
            frekvenca       = null, 
            produktBdBasic  = null;
        let current     = new Date(), 
            diff        = null, 
            starost     = null; 
        
        if (paket !== appCustomTypes.PaketBDCA.BDCA_BASIC) {
            datumRojstva    = this.calcParams['datumRojstva'];
            razmerje        = this.calcParams['razmerje'];
            diff            = new Date((current.getTime() - datumRojstva)),
            starost         = Math.abs(diff.getUTCFullYear() - 1970);
        }
        else {
            frekvenca       = this.calcParams['frekvenca'];
            produktBdBasic  = this.calcParams['produktBdBasic'];
        }
        
        switch (paket) {
            case appCustomTypes.PaketBDCA.BDCA_STANDARD:
                appLogDebug('standardChoice');
                if (razmerje === 'C' && starost >= 0 && starost <= 18) {
                    this.premija = {
                        neto: 7.69,
                        davek: 0.65,
                        bruto: 8.34
                    };
                }
                else if (razmerje === 'A' && starost > 18 && starost <= 64) {
                    this.premija = {
                        neto: 22.03,
                        davek: 1.87,
                        bruto: 23.90
                    };
                }
                else if (razmerje === 'A' && starost > 64 && starost <= 84) {
                    this.premija = {
                        neto: 27.49,
                        davek: 2.34,
                        bruto: 29.82
                    };
                }
                break;

            case appCustomTypes.PaketBDCA.BDCA_PREMIUM:
                if (razmerje === 'C' && starost >= 0 && starost <= 18) {
                    this.premija = {
                        neto: 13.75,
                        davek: 1.17,
                        bruto: 14.92
                    };
                }
                else if (razmerje === 'A' && starost > 18 && starost <= 64) {
                    this.premija = {
                        neto: 35.00,
                        davek: 2.98,
                        bruto: 37.98
                    };
                }
                else if (razmerje === 'A' && starost > 64 && starost <= 84) {
                    this.premija = {
                        neto: 46.66,
                        davek: 3.97,
                        bruto: 50.63
                    };
                }
                break;

            case appCustomTypes.PaketBDCA.BDCA_BASIC:
                // Individualno mesecno
                /**/
                if (produktBdBasic === 'Individualni' && frekvenca === 'MESECNO') {
                    this.premija = {
                        neto: 5.44,
                        davek: 0.46,
                        bruto: 5.90
                    };
                }
                else if (produktBdBasic === 'Individualni' && frekvenca === 'LETNO') {
                    this.premija = {
                        neto: 65.25,
                        davek: 5.55,
                        bruto: 70.80
                    };  
                }
                else if (produktBdBasic === 'Družinski' && frekvenca === 'MESECNO') {
                    this.premija = {
                        neto: 9.12,
                        davek: 0.78,
                        bruto: 9.90
                    };
                }
                else if (produktBdBasic === 'Družinski' && frekvenca === 'LETNO') {
                    this.premija = {
                        neto: 109.49,
                        davek: 9.31,
                        bruto: 118.80
                    };
                }

                break;

            default:
                break;
        }

        return this;

    }
}

module.exports = {
    BdcaPremija  
};